// Week 7 / Day 5 — Проект недели: service dashboard + опыт «Монетка и инерция» / Service Dashboard + Coin Inertia
// Solid Grade 6 math + RU Grade 3–4 + safe practical coin-inertia experiment.

export const maxWeek7Day5 = {
  id: 'max-week-7-day-5',
  studentId: 'max',
  weekId: 'week-7',
  dayId: 'day-5',
  title: 'Проект недели: service dashboard и опыт «Монетка и инерция» / Week Project: Service Dashboard and Coin Inertia',
  shortTitle: 'Service dashboard / Service Dashboard',
  theme:
    'Итог недели: собрать service dashboard и провести безопасный опыт «Монетка и инерция». / Wrap-up: service dashboard and a safe coin-inertia experiment.',
  estimatedTimeLabel: 'Онлайн: 30–40 мин. Полный день: 90–110 мин. / Online: 30–40 min. Full day: 90–110 min.',
  nimnyIntro:
    'Нимни ведёт Макса через процент успеха, процентные пункты, dashboard, уравнение проекта, сравнение эффективности и опыт про инерцию. / Nimny walks Max through success %, percentage points, dashboard, project equation, efficiency comparison and the coin-inertia experiment.',
  goals: [
    'Слой 1. Математика / Layer 1. Math: процент успеха, процентные пункты, среднее/размах, уравнение, сравнение unit rate (Grade 6). / success %, percentage points, mean/range, equation, unit rate comparison.',
    'Слой 2. Русский / Layer 2. Russian: части речи, безударные, исправление.',
    'Слой 3. Чтение и письмо / Layer 3. Reading: текст об опыте и инерции + план + 4 предложения.',
    'Слой 4. Логика и анализ данных / Layer 4. Logic and data analysis: почему монетка падает в стакан.',
    'Слой 5. Практика: service dashboard + опыт «Монетка и инерция» с родителем. / Practical: service dashboard + coin-inertia experiment with parent.',
    'Дневник мышления / Thinking Diary.',
    'Награда нимами / Reward in nims: 5/9.'
  ],
  vocabulary: [
    { term: 'инерция / inertia', definition: 'тело сохраняет своё состояние движения или покоя / body keeps its state of motion or rest' },
    { term: 'монетка / coin', definition: 'маленький круглый металлический предмет / small round metal object' },
    { term: 'стакан / cup', definition: 'пластиковый сосуд для опыта / plastic cup for the experiment' },
    { term: 'карточка / card', definition: 'плотный лист бумаги / stiff sheet of paper' },
    { term: 'движение / motion', definition: 'изменение положения тела во времени / change of position over time' },
    { term: 'вывод / conclusion', definition: 'что я понял из наблюдений / what I understood from observation' }
  ],
  onlineTasks: [
    { id: 'q1', type: 'math', title: 'Результаты опыта / Experiment results',
      prompt: 'Из 20 попыток монетка попала в стакан 14 раз. Какой процент успеха? / Success % of 14/20.',
      helper: 'Часть ÷ целое. / Part / whole.',
      answer: '70%. / 70%.', unit: '%' },
    { id: 'q2', type: 'math', title: 'Улучшение результата / Improvement',
      prompt: 'Серия 1: 60% успеха. Серия 2: 20 попыток и 75% успеха. Сколько успешных попыток в серии 2 и на сколько процентных пунктов вырос результат? / 75% of 20; then 75 − 60 pp.',
      helper: '0.75 × 20; пункты — разница процентов. / 0.75 × 20; points = %-difference.',
      answer: '15 успешных; +15 процентных пунктов. / 15 successes; +15 pp.', unit: '' },
    { id: 'q3', type: 'math', title: 'Service dashboard / Service dashboard',
      prompt: 'План 8, качество 9, скорость 7, проверка 10. Найди средний балл и размах. / Mean and range.',
      helper: '4 значения; среднее и размах. / Mean and range.',
      answer: 'Среднее 8.5; размах 3. / Mean 8.5; range 3.', unit: '' },
    { id: 'q4', type: 'math', title: 'Уравнение проекта / Project equation',
      prompt: 'x задач планирования + 2x выполнения + (x + 6) проверки = 62. Найди x. / Solve x.',
      helper: '4x + 6 = 62. / Combine.',
      answer: 'x = 14. / x = 14.', unit: 'задач / tasks' },
    { id: 'q5', type: 'math', title: 'Сравнение эффективности / Efficiency comparison',
      prompt: 'A: 18 задач за 45 мин. B: 24 задачи за 72 мин. У кого выше скорость задач в минуту? / Tasks/min for each.',
      helper: 'Задачи ÷ минуты. / Tasks / minutes.',
      answer: 'A быстрее (0.4 vs ≈ 0.333). / A is faster.', unit: 'зад/мин / tasks/min' },
    { id: 'q6', type: 'classify', title: 'Части речи / Parts of speech',
      prompt: 'Распредели по частям речи. / Sort by part of speech.',
      categories: [
        { id: 'noun', label: 'Существительное / Noun' },
        { id: 'verb', label: 'Глагол / Verb' },
        { id: 'adj', label: 'Прилагательное / Adjective' }
      ],
      items: [
        { id: 'w1', text: 'монетка / coin' },
        { id: 'w2', text: 'быстрый / fast' },
        { id: 'w3', text: 'наблюдать / to observe' },
        { id: 'w4', text: 'стакан / cup' },
        { id: 'w5', text: 'плотный / dense' },
        { id: 'w6', text: 'записать / to record' }
      ] },
    { id: 'q7', type: 'text', title: 'Исправь ошибки / Fix mistakes',
      prompt: 'Перепиши без ошибок: «манетка падает в стакан, потамучто карточка быстра уходит в сторону». / Rewrite without mistakes.',
      placeholder: 'Монетка падает... / The coin falls...' },
    { id: 'q8', type: 'text', title: 'Главная мысль и план / Main idea and plan',
      prompt: 'Прочитай текст «Опыт и инерция» на печатном листе. Запиши главную мысль, план из 3 пунктов и 4 предложения. / Read; main idea + plan + 4 sentences.',
      placeholder: 'Главная мысль: ... / Main idea: ...' },
    { id: 'q9', type: 'text', title: 'Опыт: монетка и инерция / Experiment: coin and inertia',
      prompt: 'С родителем: 1) пластиковый стакан; 2) плотная карточка на стакан; 3) монетка сверху; 4) быстро щёлкни карточку в сторону; 5) наблюдай, как монетка падает в стакан; 6) повтори несколько раз. Запиши: всего попыток, попало, не попало, процент, что заметил, почему, вывод. Безопасность: только с родителем, пластиковый стакан, не щёлкать в сторону лица, убрать монетки после. / With parent: plastic cup + stiff card + coin; flick card sideways; observe; repeat; record attempts / hits / misses / % / observation / why / conclusion. Safety: parent-supervised, plastic cup, not toward face, put coins away after.',
      placeholder: 'Всего: ____; попало: ____; %: ____; вывод: ...' },
    { id: 'q10', type: 'text', title: 'Логика: почему монетка падает в стакан / Logic: why the coin drops into the cup',
      prompt: 'Ответь 3–4 предложениями: почему монетка не летит вместе с карточкой? Что такое инерция? / 3–4 sentences on inertia.',
      placeholder: 'Монетка сначала... / At first the coin...' },
    { id: 'q11', type: 'essay', title: 'Мой service dashboard недели / My weekly service dashboard',
      prompt: 'Опиши проект недели: проблема, кто помогает, какой план, ресурсы, как проверить качество, вывод недели. / Weekly project: problem, helpers, plan, resources, quality check, conclusion.',
      minSentences: 4, maxSentences: 10, placeholder: 'Проблема: ... Кто помогает: ... План: ... Ресурсы: ... Проверка: ... Вывод недели: ...' }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 7, День 5». / Heading.',
    'Слой 1. Математика: q1–q5. / Math tasks.',
    'Слой 2. Русский: части речи + исправление. / Russian.',
    'Слой 3. Чтение: главная мысль + план + 4 предложения. / Reading.',
    'Слой 4. Логика: инерция и монетка. / Logic.',
    'Слой 5. Практика: опыт + service dashboard. / Practical.',
    'Дневник мышления / Thinking diary.',
    'Награда нимами. / Reward.'
  ],
  printWorksheet: {
    title: 'Неделя 7, День 5 / Week 7, Day 5',
    subtitle: 'Проект недели: service dashboard и опыт «Монетка и инерция» / Week Project: Service Dashboard and Coin Inertia',
    pages: [
      { title: 'Маршрут дня: пять слоёв обучения / Daily route: five learning layers', blocks: [
        { type: 'list', items: [
          '1. Математика / Math — 30–35 мин / min.',
          '2. Русский язык / Russian — 15–20 мин / min.',
          '3. Чтение и письмо / Reading and writing — 10–15 мин / min.',
          '4. Логика и анализ данных / Logic and data analysis — 5–10 мин / min.',
          '5. Практика: опыт + service dashboard / Practical: experiment + dashboard — 20–25 мин / min.',
          '6. Дневник мышления / Thinking diary — 5 мин / min.',
          '7. Награда нимами / Reward in nims.'
        ] }
      ] },
      { title: 'Слой 1. Математика / Layer 1. Math', blocks: [
        { type: 'text', text: 'Grade 6: проценты, процентные пункты, среднее/размах, уравнения, unit rate. Показывай шаги. / Show steps.' },
        { type: 'list', items: [
          '1) 14 ÷ 20 = ____ = ____%. / Success %.',
          '2) 75% × 20 = ____ успешных; рост в процентных пунктах = 75% − 60% = ____ п.п. / Improvement.',
          '3) 8 + 9 + 7 + 10 = ____. Среднее = ____ ÷ 4 = ____. Размах = 10 − 7 = ____. / Dashboard.',
          '4) x + 2x + (x + 6) = 62. 4x + 6 = ____. 4x = ____. x = ____. Планирование ____, выполнение ____, проверка ____. / Equation.',
          '5) A: 18 ÷ 45 = ____ зад/мин. B: 24 ÷ 72 = ____ зад/мин. Быстрее: ____. / Unit rate.',
          '6) Проверка / Check: 14 + 6 = 20? / Verify.',
          '7) Optional / Доп.: если успех вырастет с 70% до 90%, +____ п.п. / Extra pp.',
          '8) Optional / Доп.: 15 из 20 = ____%. / Extra %.'
        ] }
      ] },
      { title: 'Слой 2. Русский язык и правописание / Layer 2. Russian Language and Spelling', blocks: [
        { type: 'text', text: 'Правило / Rule: части речи по вопросу; безударные проверяем ударением. / Parts of speech + unstressed.' },
        { type: 'list', items: [
          'Словарь / Vocabulary: инерция, монетка, стакан, карточка, движение, вывод, наблюдение, опыт.',
          'Части речи / Parts of speech: монетка, быстрый, наблюдать, стакан, плотный, записать — раздели.',
          'Исправь ошибки / Fix mistakes: «манетка падает в стакан, потамучто карточка быстра уходит в сторону».',
          'Мини-диктант / Mini-dictation: «Монетка падает в стакан, потому что карточка быстро уходит в сторону».',
          'Орфограмма дня / Spelling rule: слитно/раздельно (потому что) + безударные. / "Because" spacing + unstressed.'
        ] }
      ] },
      { title: 'Слой 3. Чтение, письмо и пересказ / Layer 3. Reading, Writing and Retelling', blocks: [
        { type: 'list', items: [
          'Текст «Опыт и инерция» / Text: Опыт — это способ увидеть закон, о котором раньше только слышал. Когда карточку резко щёлкают в сторону, монетка сначала стоит на месте: у неё есть инерция — она сохраняет своё состояние. Затем карточка уходит, и монетку удерживает только сила тяжести — поэтому она падает вниз, в стакан. Так простой опыт показывает, что тела не любят «сразу» менять движение; сначала они спорят с этим. Наблюдение помогает понять физику лучше, чем просто определение. / An experiment shows a law you only heard about. Flicking the card sideways, the coin stays first — inertia. Then gravity pulls it down into the cup. Bodies "argue" before changing motion. Observing beats mere definitions.',
          'Главная мысль / Main idea: __________________________________',
          'План из 3 пунктов / 3-point plan: 1) ______ 2) ______ 3) ______',
          '4 своих предложения об опыте / 4 sentences: ______________________________',
          'Пересказ родителю 3–5 предложений по-русски / Retell in 3–5 Russian sentences ✓.'
        ] }
      ] },
      { title: 'Слой 4. Логика и анализ данных / Layer 4. Logic and Data Analysis', blocks: [
        { type: 'text', text: 'Данные: 20 попыток, 14 успех, 6 неудач; вторая серия — 15/20. / Data.' },
        { type: 'list', items: [
          'Как ты объяснишь, почему монетка падает в стакан? / Explain in your own words.',
          'Что произошло бы, если щёлкать медленно? / What if the flick were slow?',
          'Мой аргумент / My argument: __________________________________',
          'Вывод / Conclusion: карточка уходит быстро, монетка не успевает двинуться — падает вниз. / Card leaves quickly; coin cannot follow — falls down.',
          'Какая была ошибка чаще всего? / What was the most common miss?'
        ] }
      ] },
      { title: 'Слой 5. Практические знания: опыт + service dashboard / Layer 5. Practical Knowledge: experiment + dashboard', blocks: [
        { type: 'text', text: 'Безопасность / Safety: только с родителем; пластиковый стакан; не щёлкать в сторону лица; после опыта убрать монетки. / Parent-supervised; plastic cup; not toward face; put coins away.' },
        { type: 'list', items: [
          'Опыт «Монетка и инерция» / Coin-inertia experiment:',
          '1) Пластиковый стакан на столе. / Plastic cup.',
          '2) Плотная карточка на стакан. / Stiff card on top.',
          '3) Монетка в центре карточки. / Coin in center of card.',
          '4) Быстро щёлкни карточку в сторону. / Flick card sideways.',
          '5) Наблюдай, куда падает монетка. / Observe where coin falls.',
          '6) Повтори несколько раз. / Repeat.',
          'Всего попыток / Attempts: ____; попало / hits: ____; не попало / misses: ____.',
          'Процент успеха / Success %: ____ ÷ ____ = ____%.',
          'Service dashboard недели / Weekly service dashboard:',
          'Проблема / Problem: __________________________________',
          'Кто помогает / Who helps: __________________________________',
          'План / Plan: __________________________________',
          'Ресурсы / Resources: __________________________________',
          'Как проверить качество / How to check quality: __________________________________',
          'Вывод недели / Weekly conclusion: __________________________________'
        ] }
      ] },
      { title: 'Дневник мышления / Thinking Diary', blocks: [
        { type: 'list', items: [
          'Что новое я понял на опыте / What I learned from the experiment: ______',
          'Самое важное слово / Most important word: ______'
        ] }
      ] },
      { title: 'Родительская проверка и награда нимами / Parent check and reward in nims', blocks: [
        { type: 'list', items: [
          'Базовая награда / Base reward: 5 нимов / nims ✓',
          'Бонус за процентные пункты и уравнение / Bonus for percentage points + equation: +1 ☐',
          'Бонус за dashboard / Bonus for dashboard: +1 ☐',
          'Бонус за безопасный опыт / Bonus for a safe experiment: +1 ☐',
          'Бонус за вывод недели / Bonus for weekly conclusion: +1 ☐',
          'Итого / Total: ____ из / of 9 нимов / nims'
        ] }
      ] }
    ]
  },
  parentGuide: {
    goal:
      'Grade 6: 14/20 = 70%; 75% × 20 = 15 и +15 п.п.; {7,8,9,10}: среднее 8.5, размах 3; уравнение x + 2x + (x+6) = 62 → x = 14; 0.4 vs ≈ 0.333, A быстрее. Русский Grade 3–4. Опыт «Монетка и инерция» безопасен с родителем. / Grade 6 math + safe coin-inertia experiment.',
    mathGoal: 'q1: 70%. q2: 15 успешных, +15 п.п. q3: 8.5 и 3. q4: x = 14 (14/28/20). q5: A (0.4 > 0.333). / Listed with steps.',
    russianGoal: 'Существительные: монетка, стакан. Глаголы: наблюдать, записать. Прилагательные: быстрый, плотный. / Correct sorting.',
    readingWritingGoal: 'Главная мысль: опыт объясняет инерцию лучше определения. План + 4 предложения. / Main idea + plan + 4 sentences.',
    practicalGoal: 'Опыт «Монетка и инерция» с родителем + service dashboard недели. / Coin-inertia experiment + weekly dashboard.',
    check: [
      'Q1: 70%.',
      'Q2: 15 успешных; +15 п.п.',
      'Q3: 8.5 и 3.',
      'Q4: x = 14.',
      'Q5: A быстрее.',
      'Части речи разобраны. / Parts of speech.',
      'Главная мысль + план + 4 предложения. / Main idea + plan + 4 sentences.',
      'Опыт проведён безопасно с родителем. / Experiment safe.',
      'Service dashboard с выводом недели. / Dashboard + weekly conclusion.'
    ],
    answerKey: [
      { taskId: 'q1', answer: '14 ÷ 20 = 0.7 = 70%.' },
      { taskId: 'q2', answer: '0.75 × 20 = 15 успешных; рост 75% − 60% = 15 процентных пунктов.' },
      { taskId: 'q3', answer: 'Сумма 34; среднее 34 ÷ 4 = 8.5; размах 10 − 7 = 3.' },
      { taskId: 'q4', answer: 'x + 2x + (x + 6) = 62; 4x + 6 = 62; 4x = 56; x = 14. Планирование 14, выполнение 28, проверка 20.' },
      { taskId: 'q5', answer: 'A: 18 ÷ 45 = 0.4 зад/мин; B: 24 ÷ 72 = 0.333… зад/мин; A быстрее.' },
      { taskId: 'q6', answer: 'Существительные: монетка, стакан. Глаголы: наблюдать, записать. Прилагательные: быстрый, плотный.' },
      { taskId: 'q7', answer: 'Монетка падает в стакан, потому что карточка быстро уходит в сторону.' },
      { taskId: 'q8', answer: 'Главная мысль: опыт показывает инерцию лучше определения. План: 1) карточка уходит быстро; 2) монетка не успевает; 3) сила тяжести опускает её в стакан. 4 предложения — открытый ответ.' },
      { taskId: 'q9', answer: 'Ожидаемое: 15–20 попыток; успех обычно 60–80%. Ребёнок фиксирует всего/попало/не попало и вывод. Safety соблюдена. / Attempts + hits + %; safety respected.' },
      { taskId: 'q10', answer: 'Монетка сначала стоит на месте (инерция), карточка уходит, сила тяжести опускает монетку вниз в стакан. / Coin stays first (inertia); card leaves; gravity pulls coin down.' },
      { taskId: 'q11', answer: 'Открытый ответ: 6 полей dashboard + вывод недели. / Open answer.' }
    ],
    experimentAnswerKey: 'Ожидаемое наблюдение: карточка быстро уходит в сторону, монетка сначала остаётся на месте из-за инерции, затем падает вниз в стакан под действием силы тяжести. Если щёлкнуть медленно — карточка тянет монетку с собой. / Fast flick: card leaves, coin drops. Slow flick: card drags coin.',
    spellingCheck: 'Части речи + «потому что» раздельно; безударные правильно. / Parts of speech + "potomu chto" spacing.',
    readingCheck: 'Главная мысль ясная; план 3 пункта; 4 предложения; пересказ 3–5 предложений. / Main idea + plan + retelling.',
    notebookCheck: 'Все 5 слоёв заполнены. / All 5 layers.',
    printCheck: 'Все 8 страниц заполнены. / All 8 pages.',
    discussionPrompts: [
      'Что тебя удивило в опыте? / What surprised you?',
      'Когда ты уже видел похожее явление? / Where else have you seen this?',
      'Что бы ты изменил в опыте, чтобы улучшить результат? / What would you change?',
      'Как объяснить инерцию младшему брату/сестре? / Explain to a younger sibling.'
    ],
    ifEasy: 'Усложни: сравни успех до и после тренировки в процентных пунктах. / Extend: compare in percentage points.',
    ifDifficult: 'Оставь q1, q3 и опыт. / Keep q1, q3 and experiment.',
    rubric: [
      'Математика: 4 из 5 задач решены с шагами. / 4/5 math with steps.',
      'Русский: части речи + исправление. / Parts of speech + correction.',
      'Чтение: главная мысль + план + 4 предложения. / Reading essentials.',
      'Логика: 3–4 предложения про инерцию. / Logic paragraph.',
      'Опыт: безопасность соблюдена; записаны попытки, попадания, процент. / Safety + attempts/hits/%.',
      'Dashboard: 6 полей + вывод недели. / Dashboard complete.',
      'Награда: 5 базовых + до 4 бонусов (максимум 9). / 5 base + up to 4 bonuses (max 9).'
    ],
    safetyNotes: 'Только с родителем. Пластиковый стакан, не стекло. Не щёлкать карточку в сторону лица. После опыта убрать монетки. / Parent-supervised; plastic cup; not toward face; put coins away.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim', unitName: 'ним', base: 5, max: 9,
    label: 'Награда за проект недели / Week project reward', display: '5 нимов / 5 nims',
    bonuses: [
      { id: 'pp-eq', label: 'Бонус за процентные пункты и уравнение / Bonus for percentage points + equation', amount: 1 },
      { id: 'clean-dashboard', label: 'Бонус за dashboard / Bonus for dashboard', amount: 1 },
      { id: 'safe-experiment', label: 'Бонус за безопасный опыт / Bonus for a safe experiment', amount: 1 },
      { id: 'weekly-conclusion', label: 'Бонус за вывод недели / Bonus for a weekly conclusion', amount: 1 }
    ]
  },
  completionRequirements: { requiredTaskIds: ['q1', 'q4', 'q8', 'q9', 'q11'], allowNotebookCompletion: true },
  unlockAfter: { weekId: 'week-7', dayId: 'day-4' },
  nextLessonId: 'max-week-8-day-1'
};

export default maxWeek7Day5;
